import { Backdrop } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

interface Props {
  open: boolean;
}

export const GlobalLoading = ({ open }: Props) => {
  return (
    <Backdrop
      sx={{
        color: 'primary.main',
        zIndex: (theme) =>
          theme.zIndex.drawer > 1300 ? theme.zIndex.drawer + 1 : 1301,
      }}
      open={open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default GlobalLoading;
